<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-04-15 16:55:30
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-04-26 15:32:56
-->
<template>
	<div class="talent-info">
		<yx-avatar :size="40" :src="row.head" />
		<div class="right">
			<div class="info">
				<platform-icon style="flex-shrink: 0" :platformId="row.platform_id" />
				<el-tooltip placement="top" :content="row.anchor_name">
					<div class="ml-4 ellipsis hover cursor-pointer" @click="showDetailDrawer(row)">{{ row.anchor_name }}</div>
				</el-tooltip>
				<level-tag v-if="$isDy()" class="ml-4" :lv="row.anchor_level" />
				<!-- <drIntroduction v-if="row.have_contact" class="ml-2" :isShowInfo="isShowInfo" :anchorId="row.anchor_id" /> -->
				<IntroductionDialog v-if="showIntroduction" :isShowInfo="isShowInfo" :anchorId="row.anchor_id" :source="source" />
			</div>
			<div class="yx-color-text-secondary font-h6-regular flex-row mt-2">
				<template v-if="$isDy(row.platform_id)">
					<span style="white-space: nowrap">{{ row.platform_id | formatPlatformName('suf') }}：</span>
					<el-tooltip placement="top" :content="row.anchor_account" v-ak-tooltip-auto-show :open-delay="300">
						<span class="line-ellipsis" style="max-width: 75px">{{ row.anchor_account | formatEmpty }}</span>
					</el-tooltip>
				</template>
				<template v-if="$isKs(row.platform_id)">
					<span style="white-space: nowrap">{{ row.platform_id | formatPlatformName('suf') }}：</span>
					<el-tooltip placement="top" :content="row.anchor_uid" v-ak-tooltip-auto-show :open-delay="300">
						<span class="line-ellipsis" style="max-width: 75px">{{ row.anchor_uid | formatEmpty }}</span>
					</el-tooltip>
				</template>
				<template v-if="pageName != 'clueSeas' && $isSp(row.platform_id)">
					<span style="white-space: nowrap">{{ row.platform_id | formatPlatformName('suf') }}：</span>
					<el-tooltip placement="top" :content="row.anchor_uid" v-ak-tooltip-auto-show :open-delay="300">
						<span class="line-ellipsis" style="max-width: 75px">{{ row.anchor_uid || '暂无' }}</span>
					</el-tooltip>
				</template>
			</div>
			<div style="height: 20px">
				<el-tooltip placement="top" :content="catesText" v-ak-tooltip-auto-show :open-delay="300">
					<div class="yx-color-text-secondary font-h6-regular line-ellipsis" style="max-width: 138px">
						<span v-if="$isPlatOr(row.platform_id, ['Dy', 'Ks'])">主推类目：</span>
						<span v-if="$isSp(row.platform_id)">账号分类：</span>
						<template v-if="row.recommend_type && row.recommend_type.length">
							<span v-for="(item, index) in row.recommend_type" :key="index">
								{{ item }}
								<span v-if="row.recommend_type.length > 1 && index !== row.recommend_type.length - 1">/</span>
							</span>
						</template>
						<span v-else>-</span>
					</div>
				</el-tooltip>
			</div>
			<SpVerify
				@refresh="handleSpVerify"
				:anchoId="row.anchor_id"
				:anchorUid="row.anchor_uid"
				v-if="$isSp(row.platform_id)"
				:type="row.check_status"
			/>
			<div class="auth" :class="{ ks: $isKs(row.platform_id) }" v-if="row.anchor_auth_status">{{ row.platform_id | formatPlatformName }}授权</div>
			<slot></slot>
		</div>
	</div>
</template>

<script>
// import drIntroduction from '@/components/business/drIntroduction';
import IntroductionDialog from '@/views/talentCRM/components/introductionDialog';
import SpVerify from '@/components/business/SpVerify';
import popover from '@/views/talentCRM/myTalent/components/popover';
import mixin from '@/components/tableCells/mixin';
import { CLUE_SEAS, EMPHASIS_TALENT, MY_TALENT, GROUP_SEAS } from '@/utils/newDataMap/talentCRM';

export default {
	name: 'talentInfo',
	mixins: [mixin],
	props: {
		row: {
			type: Object,
			default: _ => ({}),
		},
		pageName: {
			type: String,
			default: 'myTalent',
		},
	},
	inject: {
		showDetailDrawer: {
			default: () => {},
		},
		checkTalentCRMPermission: {
			default: () => {
				return {
					auth: false,
				};
			},
		},
		refresh: {
			from: 'refresh',
			default: _ => _ => ({}),
		},
	},
	components: {
		// drIntroduction,
		IntroductionDialog,
		popover,
		SpVerify,
	},
	computed: {
		source() {
			const path = this.$route.path;
			const sourceMap = new Map([
				[CLUE_SEAS.path, CLUE_SEAS.source],
				[EMPHASIS_TALENT.path, EMPHASIS_TALENT.source],
				[MY_TALENT.path, MY_TALENT.source],
				[GROUP_SEAS.path, GROUP_SEAS.source],
			]);
			return sourceMap.get(path);
		},
		isShowInfo({ row }) {
			return this.source === CLUE_SEAS.source ? row.is_contact : true;
		},
		showIntroduction() {
			if (this.source === CLUE_SEAS.source) {
				return this.row.have_contact;
			} else {
				return this.checkTalentCRMPermission.auth || this.row.have_contact;
			}
		},
		catesText() {
			return this.row?.recommend_type?.reduce((total, current, index) => (total += `${index ? '/' : ''}${current}`), '');
		},
	},
	methods: {
		handleSpVerify() {
			this.refresh();
		},
	},
};
</script>

<style lang="less" scoped>
.talent-info {
	display: flex;
	.right {
		margin-left: 8px;
		font-size: 14px;
		color: #666;
		flex: 1;
		overflow: hidden;
		.info {
			display: flex;
			align-items: center;
			color: #333;
			.id-tag {
				border-radius: 2px;
				background-color: #f5f5f5;
				height: 18px;
				width: 18px;
				line-height: 18px;
				text-align: center;
				font-size: 14px;
				color: #666;
			}
		}
		.auth {
			margin: 4px 0px;
			width: 60px;
			height: 18px;
			line-height: 18px;
			font-size: 12px;
			text-align: center;
			border-radius: 2px;
			background-color: #e9f1ff;
			color: @color-primary;
			&.ks {
				background-color: #fef3e7;
				color: #fa8f14;
			}
		}
	}
}
</style>
